import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"

import { Container, Navbar, Nav, Button } from "react-bootstrap"
import { Link } from "gatsby"

import SMLogo from "../images/logos/SM-logo-white.png"
import SSLogo from "../images/logos/SS-logo-white.png"

const Header = ({ siteTitle }) => {
  const data = useStaticQuery(QUERY)

  const { nodeFffLanding } = data
  const { field_register } = nodeFffLanding

  return (
    <header>
      <Navbar expand="lg" variant="dark">
        <Container fluid>
          <Navbar.Brand className="header-logo d-flex align-items-center w-100">
              <div className="logo__studymelbourne">
                <a href="https://www.studymelbourne.vic.gov.au/">
                  <img src={SMLogo} alt="Study Melbourne" />
                </a>
              </div>
              <div className="logo__startspace">
                <a href="https://startspacehq.com/">
                  <img src={SSLogo} alt="Startspace" />
                </a>
            </div>
          </Navbar.Brand>
          <div className="d-flex justify-content-between flex-fill ml-auto">
            <Nav className="socials d-flex flex-row justify-content-between">
              <Link
                to="https://www.youtube.com/channel/UCovxORj-HKHcwmcAoCrkxVw"
                className="icon__youtube icon"
              ></Link>
              <Link
                to="https://www.linkedin.com/company/startspacehq/"
                className="icon__ln icon"
              ></Link>
              <Link
                to="https://instagr.am/StartSpaceHQ"
                className="icon__insta icon"
              ></Link>
              <Link
                to="https://twitter.com/StartSpaceHQ"
                className="icon__twitter icon"
              ></Link>
            </Nav>
            <Button variant="register" href={field_register.uri}>
              {field_register.title}
            </Button>
          </div>
        </Container>
      </Navbar>

      <Navbar expand="lg" className="nav__menu d-flex">
        <Navbar.Toggle aria-controls="page-nav" className="ml-auto" />
        <Navbar.Collapse id="page-nav">
          <Nav className="mx-auto">
            <Nav.Item className="nav__menu-item">
              <Link to="/">Home</Link>
            </Nav.Item>
            <Nav.Item className="nav__menu-item">
              <Link to="/roadshow">Roadshow</Link>
            </Nav.Item>
            <Nav.Item className="nav__menu-item">
              <Link to="/festival">Festival</Link>
            </Nav.Item>
            <Nav.Item className="nav__menu-item">
              <Link to="/pitch-competition">Pitch Competition</Link>
            </Nav.Item>
            <Nav.Item className="nav__menu-item">
              <Link to="/scholarship">Scholarship</Link>
            </Nav.Item>
            <Nav.Item className="nav__menu-item">
              <Link to="/partners">Partners & Sponsors</Link>
            </Nav.Item>
            {/*menu.nodes.map((menuItem, index) => (
              <Nav.Item className="nav__menu-item" key={index}>
                <Link to={menuItem.url}>{menuItem.title}</Link>
              </Nav.Item>
            ))*/}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </header>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header

const QUERY = graphql`
  query {
    SMLogo: file(relativePath: { eq: "logos/SM-logo-white.png" }) {
      childImageSharp {
        fluid(maxWidth: 250) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    SSLogo: file(relativePath: { eq: "logos/SS-logo-white.png" }) {
      childImageSharp {
        fluid(maxWidth: 250) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    nodeFffLanding(field_site: { eq: "fff2021" }) {
      field_register {
        uri
        title
      }
    }
    menu: allMenuItems(filter: { menu_name: { eq: "fff2021" } }) {
      nodes {
        title
        url
      }
    }
  }
`
